"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductImplementationDashboardSearchResponse = void 0;
const common_1 = require("../../common");
const product_implementation_dashboard_data_response_1 = require("./product-implementation-dashboard-data.response");
class ProductImplementationDashboardSearchResponse extends common_1.PaginatedResponse {
}
exports.ProductImplementationDashboardSearchResponse = ProductImplementationDashboardSearchResponse;
//# sourceMappingURL=product-implementation-dashboard-search.response.js.map